(function (upp) {
    'use strict';

    /**
     * Render a selector or a doble selector with amount input
     *
     * Scope elements:
     *
     * - attrName1: String, name to group the attrValue1
     * - attrName2: String, name to group the attrValue2
     * - attributes: array of {
     *  id: Number
     *  attrValue1: String, optional
     *  attrValue2: String, optional
     *  price: Number
     * }
     * Represent the list of combinations for the selector with the price
     * If we dont have any element in the array without attrValue1, then the first selector is not shown
     * If we dont have any element in the array without attrValue2, then the second selector is not shown.
     * - selectedVariation: attribute selected element of the attributes array.
     *
     */
    upp.directive('productAttributesSelector', [
        function () {
            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    attributes: '=',
                    attrName1: '=',
                    attrName2: '=',
                    selectedVariation: '='
                },
                templateUrl: require('../templates/product_attributes_selector.html'),
                link: function ($scope, element) {
                    $scope.hasAttr1 = false;
                    $scope.hasAttr2 = false;
                    $scope.attr1Variations = [];
                    $scope.attr2VariationsMap = {};
                    // Initialize ng-model variables
                    $scope.attr1 = null;
                    $scope.attr2 = null;

                    var initVariations = function (attrs) {
                        /*
                         * Cases:
                         *  1.  - attrs is an array with a single position, and attrValue1 is null, and attrValue2 is null
                         *      |- Dont show the variations dropdowns
                         *  2.  - attrs is an array with more than one element
                         *      |- Draw the first dropdown containing every possible value of attrValue1
                         *  2.1 |- every element has an attrValue1 different from null, but every attrValue2 is null
                         *      ||- Don't show the dropdown associated with attrValue2
                         *  2.2 ||- every element has an attrValue1 different from  null and every attrValue2 is not null
                         *       |- Draw both dropdowns, first contains every possible value of attrValue1
                         *       |- The second dropdown values changes to the collection of attrValue2 that had the current
                         *           attrValue1
                         *       |- If no element is selected on attrValue1 dropdown, attrValue2 dropdown is disabled
                         * */

                        var firstVariation = attrs[0];

                        if (attrs.length == 1 && !attrs[0].attrValue1) { // Case 1
                            $scope.hasAttr1 = false;
                            $scope.hasAttr2 = false;
                            $scope.selectedVariation = firstVariation;
                        }
                        else if (attrs.length >= 1) { // Case 2 or Case 3
                            $scope.hasAttr1 = true;

                            // we want a list with objects with variations unique
                            $scope.attr1Variations = attrs.reduce(function(listInProgress, variation){
                                var filter = listInProgress.filter(function(elem){
                                    return elem.attrValue1 == variation.attrValue1
                                });
                                if (filter.length == 0)
                                    listInProgress.push(variation);

                                return listInProgress;
                            }, []);

                            if (firstVariation.attrValue1 && !firstVariation.attrValue2) { // Case 2
                                $scope.hasAttr2 = false;
                            } else if (firstVariation.attrValue1 && firstVariation.attrValue2) { //case 3
                                $scope.hasAttr2 = true;
                                /*
                                 * We create a map that will have the different attr1values as keys and possible attr2
                                 * that had attr1 as an array of each one.
                                 */
                                $scope.attr2VariationsMap = attrs.reduce(function (mapInProgress, variation) {
                                    mapInProgress[variation.attrValue1] = mapInProgress[variation.attrValue1] || [];
                                    mapInProgress[variation.attrValue1].push(variation);
                                    return mapInProgress;
                                }, {})
                            }
                        }
                    };


                    // Waits for 'attributes' model loading, and then
                    // * If has value, initialize the widget.
                    $scope.$watch('attributes', function (attributes) {
                        //Only init when the attributes of the product are rendered, and exist.
                        if (attributes && attributes.length) {
                            initVariations(attributes);
                        }
                    });

                    // Watcher fired when the first select change
                    $scope.$watch('attr1.id', function() {
                        $scope.attr2 = null;
                        $scope.selectedVariation = {};
                        if ($scope.attr1 && !$scope.hasAttr2) { //case 2
                            $scope.selectedVariation = $scope.attr1;
                            $scope.productPrice = $scope.attr1.price;
                        }
                    });

                    // Watcher fired when the second select change
                    $scope.$watch('attr2.id', function() {
                        if ($scope.attr2) {
                            $scope.selectedVariation = $scope.attr2;
                        }
                    });
                }
            };
        }]);
}(upp));


// WEBPACK FOOTER //
// ./src/app/plugins/products/directives/product_attributes_selector-directive.js